import { useNavigate } from "@solidjs/router";
import Text from "../components/Text";
import styles from "./Home.module.css";

export default function Home() {
    const navigate = useNavigate();
    return (
        <div class={styles.page}>
            <section class={styles.hero}>
                <div class={styles.heroBg} />
                <div class={styles.heroGrid} />
                <div class={`${styles.orb} ${styles.orb1}`} />
                <div class={`${styles.orb} ${styles.orb2}`} />
                <div class={`${styles.orb} ${styles.orb3}`} />

                <div class={styles.heroContent}>
                    <img
                        class={styles.logo}
                        src="/vektor_animated.svg"
                        alt="Vektor"
                    />
                    <p class={styles.brandName}>Vektor</p>
                    <h1 class={styles.heroTitle}>
                        <Text val="HERO_TITLE_1" />{" "}
                        <span class={styles.heroAccent}><Text val="HERO_TITLE_ACCENT" /></span>
                    </h1>
                    <p class={styles.heroSubtitle}>
                        <Text val="HERO_SUBTITLE" />
                    </p>
                    <div class={styles.heroCtas}>
                        <button class={styles.ctaPrimary} onClick={() => navigate("/register")}>
                            <i class="fa-solid fa-rocket" />
                            <Text val="HERO_CTA_DOWNLOAD" />
                        </button>
                        <button class={styles.ctaSecondary} onClick={() => {
                            document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth", block: "start" });
                        }}>
                            <i class="fa-solid fa-circle-question" />
                            <Text val="HERO_CTA_LEARN" />
                        </button>
                    </div>
                    <button type="button" class={styles.heroTrustLink} onClick={() => navigate("/security")}>
                        <i class="fa-solid fa-shield-halved" />
                        <Text val="HERO_SECURITY_LINK" />
                        <i class="fa-solid fa-arrow-right" />
                    </button>
                </div>

            </section>

            <section class={styles.features} id="features">
                <div class={styles.sectionLabel}>
                    <span class={styles.sectionLabelDot} />
                    <Text val="FEATURES_LABEL" />
                </div>
                <h2 class={styles.sectionTitle}>
                    <Text val="FEATURES_TITLE" />
                </h2>

                <div class={styles.featuresGrid}>
                    <div class={styles.featureCard}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-terminal" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_COMMANDS_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_COMMANDS_DESC" /></p>
                    </div>

                    <div class={styles.featureCard}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-boxes-stacked" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_INVENTORY_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_INVENTORY_DESC" /></p>
                    </div>

                    <div class={styles.featureCard}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-chart-line" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_JOBS_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_JOBS_DESC" /></p>
                    </div>

                    <div class={styles.featureCard}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-share-nodes" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_SHARE_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_SHARE_DESC" /></p>
                    </div>

                    <button type="button" class={`${styles.featureCard} ${styles.featureCardLink}`} onClick={() => navigate("/security")}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-shield-halved" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_SECURITY_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_SECURITY_DESC" /></p>
                        <span class={styles.featureCardCta}><Text val="TRUST_LINK" /> <i class="fa-solid fa-arrow-right" /></span>
                    </button>

                    <div class={styles.featureCard}>
                        <div class={styles.featureIcon}><i class="fa-solid fa-cubes" /></div>
                        <h3 class={styles.featureTitle}><Text val="FEATURE_DROP_TITLE" /></h3>
                        <p class={styles.featureDesc}><Text val="FEATURE_DROP_DESC" /></p>
                    </div>
                </div>
            </section>

            <section class={styles.howItWorks} id="how-it-works">
                <div class={styles.howItWorksInner}>
                    <div class={styles.sectionLabel}>
                        <span class={styles.sectionLabelDot} />
                        <Text val="STEPS_LABEL" />
                    </div>
                    <h2 class={styles.sectionTitle}>
                        <Text val="STEPS_TITLE" />
                    </h2>

                    <div class={styles.steps}>
                        <div class={styles.step}>
                            <div class={styles.stepNumber}>1</div>
                            <h3 class={styles.stepTitle}><Text val="STEP1_TITLE" /></h3>
                            <p class={styles.stepDesc}><Text val="STEP1_DESC" /></p>
                        </div>
                        <div class={styles.step}>
                            <div class={styles.stepNumber}>2</div>
                            <h3 class={styles.stepTitle}><Text val="STEP2_TITLE" /></h3>
                            <p class={styles.stepDesc}><Text val="STEP2_DESC" /></p>
                        </div>
                        <div class={styles.step}>
                            <div class={styles.stepNumber}>3</div>
                            <h3 class={styles.stepTitle}><Text val="STEP3_TITLE" /></h3>
                            <p class={styles.stepDesc}><Text val="STEP3_DESC" /></p>
                        </div>
                    </div>
                </div>
            </section>

            <section class={styles.stats}>
                <div class={styles.statsGrid}>
                    <div class={styles.statCard}>
                        <p class={styles.statValue}>Forge</p>
                        <p class={styles.statLabel}><Text val="STAT_PLATFORM" /></p>
                    </div>
                    <div class={styles.statCard}>
                        <p class={styles.statValue}>1.8.9</p>
                        <p class={styles.statLabel}><Text val="STAT_VERSION" /></p>
                    </div>
                    <div class={styles.statCard}>
                        <p class={styles.statValue}><Text val="STAT_HOSTING_VALUE" /></p>
                        <p class={styles.statLabel}><Text val="STAT_HOSTING_LABEL" /></p>
                    </div>
                    <div class={styles.statCard}>
                        <p class={styles.statValue}>&lt;50ms</p>
                        <p class={styles.statLabel}><Text val="STAT_LATENCY" /></p>
                    </div>
                </div>
            </section>

            <section class={styles.ctaSection}>
                <div class={styles.ctaBg} />
                <div class={styles.ctaContent}>
                    <h2 class={styles.ctaTitle}><Text val="CTA_TITLE" /></h2>
                    <p class={styles.ctaDesc}><Text val="CTA_DESC" /></p>
                    <button class={styles.ctaPrimary} onClick={() => navigate("/register")}>
                        <i class="fa-solid fa-rocket" />
                        <Text val="CTA_BUTTON" />
                    </button>
                </div>
            </section>

        </div>
    );
}
